export default "__VITE_ASSET__DPE24MrU__"